module.exports = "<div class=\"pop-in-text\">\r\n    <h1 style=\"color: white;text-align:center\" [@heroState]=\"state\">\r\n        {{text}}\r\n    </h1>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// C:/Users/IsaGul/Desktop/beyn-projects/commercial-front-end/src/app/shared/components/pop-in-text/pop-in-text.component.html
// module id = ../../../../../src/app/shared/components/pop-in-text/pop-in-text.component.html
// module chunks = main